import useInBrainCallbackRedirect from "../../hooks/useInBrainCallbackRedirect";
import * as c from "./DynataEngageCallbackPageRedirect.module.css";

function DynataEngageCallbackPageRedirect() {
  const { isLoading } = useInBrainCallbackRedirect();

  if (isLoading) {
    return (
      <div className={c.container}>
        <p>Redirecting...</p>
      </div>
    );
  }

  return null;
}

export default DynataEngageCallbackPageRedirect;
